<template>
  <div class="provides">
    <div class="learn-more">
      <div class="logo">
        <img class="logo" src="@/assets/image/logo_icon.png" alt="" />
        <div class="incorporated">
          Incorporated on October 22, 2022 as a C-Corporation in the State of California, Alchemy Pay, Inc. (NMLS ID: 2449570) is a payment gateway provider that seamlessly
          connects crypto and global fiat currencies for businesses, developers, and users.
        </div>
      </div>
      <div class="other">
        <div class="products">
          <ul>
            <li class="title">Products</li>
            <li class="link-name" @click="goHome">On-Ramp</li>
            <li class="link-name" @click="goHome">Off-Ramp</li>
          </ul>
        </div>
        <div class="products contact-us">
          <ul>
            <li class="title">Contact us</li>
            <li>
              <a class="email" href="mailto:info@alchemypay.org">info@alchemypay.org</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="canvas-bg">
      <canvas class="isLoaded" id="gradient-canvas1"></canvas>
    </div>
  </div>
</template>
<script>
import Gradient from "@/tool/Gradient.js";

export default {
  data() {
    return {
      gradient: null, // 渐变背景类名
    };
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    // 初始化动态背景
    initGradient(id) {
      this.gradient = new Gradient();
      this.gradient.initGradient(id);
    },
  },
  mounted() {
    this.initGradient("#gradient-canvas1");
  },
  destroyed() {
    this.gradient.pause();
  },
  created() {},
};
</script>
<style lang="scss" scoped>
#gradient-canvas {
  --gradient-color-1: #1cbaf7;
  --gradient-color-2: #1cbaf7;
  --gradient-color-3: #1509f9;
  --gradient-color-4: #961aee;
  opacity: 0;
  // filter: blur(1px);
  // -webkit-filter: blur(1px);
}
#gradient-canvas.isLoaded {
  opacity: 1;
  transition: opacity 0.5s ease-in 50ms;
}
#gradient-canvas1 {
  --gradient-color-1: #1cbaf7;
  --gradient-color-2: #1cbaf7;
  --gradient-color-3: #1509f9;
  --gradient-color-4: #961aee;
  opacity: 0;
}
#gradient-canvas1.isLoaded {
  opacity: 1;
  transition: opacity 0.5s ease-in 50ms;
  // pointer-events: none;
}
@media screen and (max-width: 1180px) {
  .provides {
    position: relative;
    height: 400px;
    overflow: hidden;
    .canvas-bg {
      width: 100%;
      position: absolute;
      top: 0;
      // left: 0;
      z-index: 0;
      canvas {
        width: 100%;
        height: auto;
      }
    }
    .learn-more {
      position: relative;
      z-index: 1;
      font-style: normal;
      color: #ffffff;
      max-width: calc(100% - 48px);
      margin: 0 auto;
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      .logo {
        img {
          width: auto;
          height: 30px;
          margin-bottom: 20px;
        }
        .incorporated {
          font-family: "Regular";
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          color: #ffffff;
        }
        .us-Licenses {
          margin-top: 30px;
          font-family: "Regular";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
          color: #ffffff;
          cursor: pointer;
        }
      }
      .other {
        margin-top: 40px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        .products {
          ul {
            li {
              font-family: "Regular";
              font-style: normal;
              font-weight: 400;
              font-size: 12px;
              color: #ffffff;
              margin-bottom: 10px;
              cursor: pointer;
            }
            li.title {
              font-family: "Bold";
              font-style: normal;
              font-weight: 700;
              font-size: 18px;
              color: #ffffff;
              cursor: auto;
            }
          }
        }
        .contact-us {
          ul {
            li {
              a {
                color: #3dfff3;
              }
            }
          }
        }
      }
    }
  }
}
@media (min-width: 1180px) and (max-width: 10000px) {
  .provides {
    position: relative;
    height: 300px;
    overflow: hidden;
    .canvas-bg {
      width: 100%;
      position: absolute;
      top: 0;
      // left: 0;
      z-index: 0;
      canvas {
        width: 100%;
        height: auto;
      }
    }
    .learn-more {
      position: relative;
      z-index: 1;

      font-style: normal;
      color: #ffffff;
      max-width: calc(1440px - 130px - 130px);
      margin: 0 auto;
      margin-top: 60px;
      display: flex;
      // justify-content: space-between;
      .logo {
        width: 660px;
        img {
          width: auto;
          height: 33px;
          margin-bottom: 24px;
        }
        .incorporated {
          font-family: "Regular";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 21px;
          color: #ffffff;
          max-width: 656px;
        }
        .us-Licenses {
          margin-top: 30px;
          font-family: "Regular";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
          color: #ffffff;
          cursor: pointer;
        }
      }
      .other {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        margin-left: 80px;
        flex: 1;
        .products {
          ul {
            li {
              font-family: "Regular";
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 19px;
              color: #ffffff;
              margin-bottom: 24px;
              cursor: pointer;
            }
            li.title {
              font-family: "Bold";
              font-style: normal;
              font-weight: 700;
              font-size: 18px;
              line-height: 24px;
              color: #ffffff;
              margin-bottom: 32px;
              cursor: auto;
            }
          }
        }
        .link-name:hover {
          text-decoration: none;
          text-decoration: underline;
        }
        .contact-us {
          ul {
            li {
              a {
                color: #3dfff3;
              }
              a:hover {
                text-decoration: none;
                border-bottom: 1px solid #3dfff3;
              }
            }
          }
        }
      }
    }
  }
}
</style>
